
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {CSSTransitionGroup} from 'react-transition-group'
import Checkbox from 'components/Checkbox'
import classnames from 'classnames'
import PhoneInput from 'react-phone-number-input'
import ChannelSelect from 'components/ChannelSelect'

export default class FormInput extends React.Component {
  static propTypes = {
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    hint: PropTypes.string,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    optional: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
    meta: PropTypes.shape({
      invalid: PropTypes.bool,
      touched: PropTypes.bool,
      active: PropTypes.bool,
      error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    }).isRequired,
    input: PropTypes.shape({
      value: PropTypes.any,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func
    }),
    small: PropTypes.bool,
    inputType: PropTypes.string
  }

  static defaultProps = {
    placeholder: null,
    type: 'text'
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      // Hacky solution for non breaking appearing animation
      setTimeout(() => {
        this.refs.input.focus()
      }, 200)
    }
  }

  render() {
    const {disabled, type, className} = this.props
    const {invalid, touched, active} = this.props.meta
    const classNames = classnames('form-input', className, `is-${type}`, {
      'is-invalid': touched && invalid,
      'is-focused': active && !disabled,
      'is-disabled': disabled
    })

    const inputClassNames = classnames('form-input_field', `is-${type}`)
    return (
      <div className={classNames}>
        <div className={inputClassNames}>
          {this.renderLabel()}
          {this.renderInput()}
          {this.renderOptionalLabel()}
          <CSSTransitionGroup
            transitionName='error'
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}>
            {this.renderErrors()}
          </CSSTransitionGroup>
        </div>
        {this.renderHint()}
      </div>
    )
  }

  renderLabel() {
    const {label, type, input: {value, name}} = this.props
    if (!label || type === 'checkbox') return null

    if (type === 'radio') {
      return <label htmlFor={`${name}_${value}`}>{label}</label>
    }

    return <label htmlFor={name}>{label}</label>
  }

  renderInput() {
    const {
      input,
      label,
      placeholder,
      type,
      disabled,
      input: {value, name, onChange},
      meta: {active, touched, invalid},
      small,
      inputType
    } = this.props

    switch (type) {
      case 'radio':
        return (
          <input
            id={`${name}_${value}`}
            {...input}
            disabled={disabled}
            autoComplete='off'
            spellCheck='false'
            placeholder={placeholder}
            type={type}
            ref='input'
          />
        )

      case 'checkbox':
        return (
          <Checkbox
            {...input}
            id={name}
            color={inputType}
            size={small ? 'small' : 'normal'}
            active={active}
            invalid={touched && invalid}
            checked={!!value}
          >
            {label}
          </Checkbox>
        )
      case 'tel':
        return (
          <PhoneInput
            {...input}
            placeholder={placeholder}
            value={value}
          />
        )
      case 'channelSelect':
        return (
          <ChannelSelect
            value={value}
            disabled={disabled}
            onSelect={value => onChange(value)}
            onChannelSelect={value => onChange(value)}
            onGroupSelect={value => onChange(value)}
          />
        )
      default:
        return (
          <input
            id={name}
            {...input}
            disabled={disabled}
            autoComplete='off'
            spellCheck={false}
            placeholder={placeholder}
            type={type}
            ref='input'
          />
        )
    }
  }

  renderOptionalLabel() {
    const {optional} = this.props

    if (!optional) return null

    const className = classnames('form-input_optional', {
      'is-normal': optional !== true
    })

    return (
      <div className={className}>{optional === true ? 'Optional' : optional}</div>
    )
  }

  renderHint() {
    const {hint} = this.props
    if (!hint) return null

    return <div className='form-input_hint'>{hint}</div>
  }

  renderErrors() {
    const {type} = this.props
    const {error, touched} = this.props.meta

    if (type === 'hidden') return null

    if (touched && error) {
      return <div className='form-input_error'>{error}</div>
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/FormInput/index.js